import React from 'react';
import { FsProps, FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';

const gqlGetValues = gql`
  query getValues($where: String, $offset: Int, $limit: Int, $order: String) {
    getTaxoffices(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: name
        description: name
        isActive
      }
      recordCount
    }
  }
`;

export const deliveryTransactionCategoriesWhere = JSON.stringify({
  useInDeliveries: 1,
  isNotActive: 0,
});

export const useGetTaxofficesAsOptionsQuery = () => {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'cache-first' });
};

interface LcFsProps extends FsProps {
  size?: 'sm' | 'lg';
}

export const FieldSelectTaxoffice = ({
  label = 'Δ.Ο.Υ.',
  name = 'companyTaxOffice',
  defaultValues = {},
  size = 'sm',
  where = undefined,
  ...rest
}: LcFsProps) => {
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      where={where}
      hook={useGetTaxofficesAsOptionsQuery}
      height={size === 'lg' ? 32 : '22'}
    />
  );
};

